module.exports = __webpack_public_path__ + "img/bird-4-right.ff7e4889.png";